// auth
export const HANDLE_AUTH_DATA = 'handleAuthData';
export const REFRESH_TOKEN = 'refreshToken';
export const TRY_AUTO_LOGIN = 'tryAutoLogin';
export const LOGOUT = 'logout';
export const GET_CURRENT_USER = 'getCurrentUser';
export const IMPERSONATE_USER = 'impersonateUser';
export const STOP_IMPERSONATING = 'stopImpersonating';
